<template>
  <div class="mb-5" style="min-height: 100vh">
    <b-row>
      <b-col cols="2">
        <b-button
          style="border: 0; color: #828282; background: transparent"
          @click="$router.go(-1)"
          ><b-icon-arrow-left-circle></b-icon-arrow-left-circle> ย้อนกลับ
        </b-button>
      </b-col>
    </b-row>
    <b-container>
      <b-row>
        <b-col cols="12">
          <img
            :src="domain + '/' + data.image"
            alt=""
            height="100%"
            width="auto"
          />
        </b-col>
        <b-col cols="12">
          <b class="float-left">{{ data.name }}</b>
        </b-col>
        <b-col cols="12 mt-1">
          <p style="text-align: left !important">
            {{ data.content }}
          </p>
        </b-col>
        <b-col
          class="mt-2 download-content"
          v-for="(x, i) in data.file"
          :key="i"
          cols="12"
        >
          <div>
            <span class="float-left">{{ x.name }}</span>
            <button
              class="px-3 py-1 float-right"
              style="
                border-radius: 25px;
                background: #41634a;
                color: white;
                border: 0;
              "
              @click="download(x.file)"
            >
              ดาวน์โหลด
            </button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { domain } from "@/utils/Constants";
import axios from "axios";

export default {
  name: "Documents",
  components: {},
  data() {
    return {
      data: [],
      domain: domain,
    };
  },
  created() {
    Swal.fire({
      title: "ระบบกำลังทำงาน",
      html: "โปรดรอสักครู่...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        this.$store
          .dispatch("dashboardModule/documentShow", this.$route.params.id)
          .then((res) => {
            this.data = res;
            if (res == 200) {
              Swal.clickConfirm();
            } else {
              Swal.clickConfirm();
            }
          });
      },
    });
  },
  methods: {
    download(file) {
      window.open(this.domain + file);

      // axios({
      //   url: this.domain + file,
      //   method: "GET",
      //   responseType: "blob",
      // }).then((response) => {
      //   var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      //   var fileLink = document.createElement("a");
      //
      //   fileLink.href = fileURL;
      //   fileLink.setAttribute("download", file);
      //   document.body.appendChild(fileLink);
      //
      //   fileLink.click();
      // });
    },
  },
};
</script>

<style scoped>
.download-content {
  background: #ffffff;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 15px;
}
</style>
